import { createContext, useContext } from 'react';

/**
 * True inside a modal's footer.
 *
 * The tab run through a modal is the fields, the confirm tick, then the primary action —
 * nothing else. `<Button>` reads this to drop the footer's non-action buttons (Cancel,
 * Autogenerate) out of the run, so the rule holds in every modal in the product rather than
 * in the ones somebody remembered to annotate.
 */
export const ModalFooterSurfaceContext = createContext(false);

export function useInModalFooter(): boolean {
  return useContext(ModalFooterSurfaceContext);
}
